import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { AggregateBusinessAdapter } from './adapters/AggregateBusinessAdapter';

/**
 * 集計のユニークキー
 */
export type AggregateBusinessUniqueKeys = {
  warehouseNumber: string;
  supplierNumber: string;
  businessNumber: string;
  package: string;
};
/**
 * 集計取引を取得するユースケース
 */
export class GetAggregateBusinessUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 集計取引を取得する
   * @param aggregateBusinessId - 集計ID
   * @param uniqueKeys - 必須キー集合
   * @returns 集計取引 or undefined
   */
  async execute(
    aggregateBusinessId?: string,
    uniqueKeys?: AggregateBusinessUniqueKeys
  ): Promise<INetworkResult<IBusiness | undefined, IError>> {
    try {
      const result = await this.repository.get(aggregateBusinessId, uniqueKeys);
      switch (result.status.type) {
        case 'success':
          const resData = AggregateBusinessAdapter.adapt(result.status.data.aggregateBusiness);
          return {
            status: {
              type: 'success',
              data: resData,
            },
          };
        case 'error':
          return {
            status: result.status,
          };
        default:
          throw new Error();
      }
    } catch (e) {
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
